import React from 'react';
import PropTypes from 'prop-types';
import { useLocalStore } from 'mobx-react-lite';

import StoreContext from './StoreContext';
import createSessionStore from './sessionStore';
import createAppStore from './appStore';

const StoreProvider = ({ children }: { children: React.ReactNode }) => {
  const sessionStore = useLocalStore(createSessionStore);
  const appStore = useLocalStore(createAppStore);

  return (
    <StoreContext.Provider
      value={{
        sessionStore,
        appStore,
      }}
    >
      {children}
    </StoreContext.Provider>
  );
};

StoreProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
};

export default StoreProvider;
